module.exports = __webpack_public_path__ + "img/foto.b46cf3a5.png";